/**
 * Filtro del menú del sidebar (no confundir con la búsqueda de clientes del
 * Header): filtra los items visibles del menú mientras se escribe.
 * Escape limpia el filtro. Oculto en modo sm/icon-only vía CSS.
 */
interface MenuFilterProps {
  value: string
  onChange: (value: string) => void
}

const MenuFilter = ({ value, onChange }: MenuFilterProps) => {
  return (
    <div className="menu-filter">
      <div className="position-relative">
        <i className="ri-search-line menu-filter-icon" aria-hidden="true"></i>
        <input
          type="search"
          className="form-control form-control-sm menu-filter-input"
          placeholder="Filtrar menú…"
          aria-label="Filtrar menú"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Escape") onChange("")
          }}
        />
      </div>
    </div>
  )
}

export default MenuFilter
